export class Owner {
  Name: string;
  EmployerId: string;
  SeniorityinBase: number;
  FFDO: number;
}

export class Defaults {
  HandleBlanks: number;
  FABidPositionChoice: number;
  FABidSelectionChoice: number;
  FABidCustomChoice: number;
  FAAddReserve: number;
}

export class Config {
  EquipInPairings: number;
  HotelsInPairings: number;
  ExternalHotels: number;
  UseOverlapCorrections: number;
  UseVacationCorrections: number;
  ShowCoverLetter: number;
  CheckReg: number;
  CheckUpdate: number;
  TripSheet: number;
  WordWrap: number;
  AppointmentBaseTime: number;
  AppointmentDutyAppt: number;
  AppointmentPairSeq: number;
}

export class Domicile {
  Code: string;
  DomicileId: number;
  DomicileName: string;
  Number: number;
}

export class Equipment {
  EquipmentId: number;
  EquipmentName: number;
  EquipmentNumber: string;
}

export class EquipType {
  Id: number;
  Name: string;
}

export class City {
  Id: number;
  Name: string;
  Code: number;
  DLST: boolean;
  International: boolean;
  NonConus: boolean;
}

export class HotelList {
  City: string;
  Hotels: string;
}

export class Hotels {
  Effective: string;
  HotelList: HotelList[];
}

export class DataColumn {
  Id: number;
  Order: number;
  Width: number;

  constructor(init?: Partial<DataColumn>) {
    Object.assign(this, init);
  }
}

export class AmPmConfigure {
  HowCalcAmPm: number;
  AmPush: string;
  AmPushTicks: number;
  AmLand: string;
  AmLandTicks: number;
  PmPush: string;
  PmPushTicks: number;
  PmLand: string;
  PmLandTicks: number;
  NitePush: string;
  NitePushTicks: number;
  NiteLand: string;
  NiteLandTicks: number;
  NumberOrPercentageCalc: number;
  NumOpposites: number;
  PctOpposities: number;
}

export class View {
  IsApplicationModern: boolean;
  IsBidLIneModern: boolean;
  IsCalenderModern: boolean;
  IsTripModern: boolean;
}

export class MiscellaneousTab {
  SplashScreen: boolean;
  Coverletter: boolean;
  DataUpdate: boolean;
  GatherData: boolean;
  IsRetrieveMissingData: boolean;
  IsMonoPDFDisplay: boolean;
}

export class AvoidanceBids {
  Avoidance1: string;
  Avoidance2: string;
  Avoidance3: string;
}

export class BuddyBids {
  Buddy1: string;
  Buddy2: string;
}
export class JobShare {
  jobshare1: string;
  jobshare2: string;
}

export class Data {
  IsCompanyData: boolean;
}

export class User {
  IsOn: boolean;
  SmartSynch: boolean;
  AutoSave: boolean;
  AutoSavevalue: number;
  MIL: boolean;
  IsCSWViewFloat: boolean;
  IsSummaryViewShade: boolean;
  InternetConnectionTimeOut: number;
  IsModernViewShade: boolean;
}

export class PairingExport {
  IsCentralTime: boolean;
  IsEntirePairing: boolean;
  IsSubjectLineSelected: boolean;
  IsFFDO: boolean;
}

export class Week {
  IsMaxWeekend: boolean;
  MaxNumber: string;
  MaxPercentage: string;
  IsMaxWeekendDefault: boolean;
  MaxNumberDefault: string;
  MaxPercentageDefault: string;
  StartDOW: string;
}

export class SourceHotel {
  SourceType: number;
}

export class Background {
  DialogColor: string;
  TextColor: string;
  AmTripsColor: string;
  PmTripsColor: string;
  MixedTripsColor: string;
  AmReserveColor: string;
  PmReserveColor: string;
  ReadyReserveColor: string;
  VacationOverlapColor: string;
  VacationDropColor: string;
  VacationColor: string;
}

export class TextColor {
  DialogText: string;
  TextBox: string;
  AmTripsText: string;
  PmTripsText: string;
  MixedTripsText: string;
  AmReserveText: string;
  PmReserveText: string;
  ReadyReserveText: string;
  VacationOverlapText: string;
  VacationDropText: string;
  VacationText: string;
}

export class Theme {
  FontType: string;
  FontSize: string;
  Background: Background;
  TextColor: TextColor;
}

export class TripViewLocation {
  Top: number;
  Left: number;
}

export class ModernTripViewLocation {
  Top: number;
  Left: number;
}

export class MainWindowSize {
  Width: number;
  Height: number;
  Left: number;
  Top: number;
  IsMaximised: boolean;
}

export class SummaryVacationColumn {
  Id: number;
  Order: number;
  Width: number;
}
export class BaseUpdates {
  constructor(
    Trips?: number,
    News?: number,
    Cities?: number,
    Hotels?: number,
    Domiciles?: number,
    Equipment?: number,
    EquipTypes?: number
  ) {
    this.Trips = Trips;
    this.News = News;
    this.Cities = Cities;
    this.Hotels = Hotels;
    this.Domiciles = Domiciles;
    this.Equipment = Equipment;
    this.EquipTypes = EquipTypes;
  }
  Trips: number;
  News: number;
  Cities: number;
  Hotels: number;
  Domiciles: number;
  Equipment: number;
  EquipTypes: number;
}

export class SenioritylistFormat {
  Id: number;
  SeqNumSt: number;
  SeqNumEnd: number;
  EbgSt: number;
  EbgEnd: number;
  BidTypeSt: number;
  BidTypeEnd: number;
  LcSt: number;
  LcEnd: number;
  EmpIdSt: number;
  EmpIdEnd: number;
  NameSt: number;
  NameEnd: number;
  ChkPltSt: number;
  ChkPltEnd: number;
  AbscenceTypeSt: number;
  AbscenceTypeEnd: number;
  AbsenceDatesSt: number;
  AbsenceDatesEnd: number;
  Round: number;
  Position: string;
}

export class INI {
  Version?: any;
  LastUpdateTime: string;
  Owner: Owner;
  Updates: BaseUpdates;
  Defaults: Defaults;
  Config: Config;
  Domiciles: Domicile[];
  Equipments: Equipment[];
  EquipTypes: EquipType[];
  Cities: City[];
  Hotels: Hotels;
  DataColumns: DataColumn[];
  AmPmConfigure: AmPmConfigure;
  CmtLinesDef?: any;
  View: View;
  MiscellaneousTab: MiscellaneousTab;
  AvoidanceBids: AvoidanceBids;
  BuddyBids: BuddyBids;
  Data: Data;
  User: User;
  PairingExport: PairingExport;
  Week: Week;
  SourceHotel: SourceHotel;
  Theme: Theme;
  hardkill: string;
  ViewType: number;
  TripViewLocation: TripViewLocation;
  ModernTripViewLocation: ModernTripViewLocation;
  MainWindowSize: MainWindowSize;
  HideFFDOMsg: boolean;
  CswViewSize?: any;
  ModernNormalColumns: number[];
  ModernVacationColumns: number[];
  BidLineNormalColumns: number[];
  BidLineVacationColumns: number[];
  SummaryVacationColumns: SummaryVacationColumn[];
  IsConnectedVofoxServer: boolean;
  RatioValues?: Ratio;
  SenioritylistFormat: SenioritylistFormat[];
}
export class Ratio{
  Numerator:number;
  Denominator:number;
}
